export const searchResults = window?.drupalSettings?.searchResults ?? {}

export const decreasingBanner = drupalSettings?.decreasingBanner

export const businessCodeFilter = window?.drupalSettings?.businessCodeFilter ?? {};

export const memberBanner = window?.drupalSettings?.memberBanner ?? {
  text: {
    firstPart: 'Save 5% on your reservation',
    secondPart: 'by becoming an Adagio Hotel member',
  },
  button: 'Become a member',
  isAnonymous: false,
  target: '_self',
  url: '#',
}

export const tid = window?.drupalSettings?.search?.api?.tid ?? ''

export const offersMockedData = window?.drupalSettings?.search?.offer ?? {}

export const hotelTitle = window?.drupalSettings?.search?.inputValue ?? null

export const pageView = window?.drupalSettings?.pageView ?? null

export const destinationsSearchPlaceholder = window?.drupalSettings?.search?.destinationsSearchPlaceholder ?? null


export const linkToFirstStep = window?.drupalSettings?.widgets?.filters?.linkToFirstStep ?? null
export const linksToFirstStep = window?.drupalSettings?.firstStepRedirectLinks ?? {
  '33c86e891ff341250ca72c16a087b268521c3db4d21447ce64e88dda912a979e': 'http://google.com',
}

export const promoCodeRemoveUlr = window?.drupalSettings?.search?.api?.promoCodeRemove ?? null

export default offersMockedData
